import HtmlString from '@/plugins/HtmlString';

const getProductImages = item => {
	if (item.productImages) {
		return item.productImages.map(image => {
			return `${image.fields.file.url}?fm=jpg&fl=progressive&w=500&q=90`;
			/* return {
				title: image.fields.title,
				url: `${image.fields.file.url}?fm=jpg&fl=progressive&w=500&q=90`
			}; */
		});
	}

	return [];
};

export default (data, store) => {
	const createMetaObject = products => {
		return products.map((item, ctfFieldIndex) => {
			const perks = [];

			for (let i = 1; i < 7; i++) {
				item['perk' + i] && perks.push(item['perk' + i]);
			}

			const meta = {
				name: item.name || '',
				tags: item.tag && item.tag.map(tag => tag.fields),
				index: ctfFieldIndex, // Ignore index value from CTF but use product order as arranged in the cms
				category: (item.extrasCategory && item.extrasCategory.fields) || {},
				image: item.image ? `${item.image.fields.file.url}?fl=progressive&w=500&q=90` : null,
				productImages: getProductImages(item),
				description: HtmlString.htmlString(item.description) || '',
				isConditionalProduct: item.isConditionalProduct,
				conditionalMessage: HtmlString.htmlString(item.conditionalMessage) || '',
				productDisclaimer: HtmlString.htmlString(item.productDisclaimer) || false,
				calculateTouristTax: typeof item.calculateTouristTax === 'boolean' ? !item.calculateTouristTax : true,
				touristTaxAmount: item.touristTaxAmount || 0,
				mentionEntertainmentFee: item.mentionEntertainmentFee || true,
				entertainmentFeeAmount: item.entertainmentFeeAmount || 0,
				additionalTicketText: item.additionalTicketText,
				serviceFees: item.serviceFees || false,
				mergeServiceFees: item.mergeServiceFees || null,
				minimumQuantity: item.minimumQuantity || 0,
				perks,
				//used for zwartecross to check if the user is 18+ when ading alcohol to the cart.
				ageCheck: item.ageCheck || false
			};

			if (item.productSideImage) {
				meta.productSideImage = `${item.productSideImage.fields.file.url}?fl=progressive&w=800&q=90`;
			}

			if (item.type === 'membership') {
				meta.membershipType = item.membershipType || 'Year'; // set year as default
			}

			if (item.type === 'ticket') {
				meta.overrideSoldout = item.overrideSoldout;

				if (item.overrideSoldout) {
					meta.soldOutTravelCtaText = item.soldOutTravelCtaText;
					meta.soldOutText = item.soldOutText;
				}
				item.productReplacements &&
					(meta.productReplacements = item.productReplacements.map(item => item.fields));
			}

			return { ...item, meta };
		});
	};

	// Add all products to store, so travel tickets can be found even when tickets aren't in the sales options.
	[
		{
			label: 'ticket',
			commit: 'setTicketMetaData'
		},
		{
			label: 'merchandise',
			commit: 'setMerchandiseMetaData'
		},
		{
			label: 'extras',
			commit: 'setExtraMetaData'
		},
		{
			label: 'comparetransport',
			commit: 'setCompareTransportMetaData'
		},
		{
			label: 'membership',
			commit: 'setMembershipMetaData'
		},
		{
			label: 'packages',
			commit: 'setPackageMetaData'
		}
	].forEach(category => {
		const saleOption = data.salesOptions.find(sale => sale.option === category.label);
		const products =
			category.label === 'packages'
				? saleOption?.products?.map(({ fields }) => fields) ?? []
				: data.products.filter(product => product && product.type === category.label);
		const metaObject = createMetaObject(products);

		store.commit(`shopconfig/${category.commit}`, metaObject);
	});
};
